import { render } from 'preact'
import { App } from './App.js'
import { applyPrefs, loadPrefs } from './prefs.js'
import { t } from './i18n/t.js'
import './styles/tokens.css'
import './styles/base.css'

// Präferenzen VOR dem ersten Render setzen, sonst springt die Oberfläche für
// genau die Nutzer, die auf große Schrift angewiesen sind.
applyPrefs(loadPrefs())

/*
 * Der Sprunglink steht in `index.html` und damit außerhalb von Preact — die
 * einzige Stelle der Oberfläche, die `t()` nicht erreicht. Er wird deshalb hier
 * gesetzt. Ihn deutsch stehen zu lassen wäre kein kleiner Schönheitsfehler:
 * Der Sprunglink ist das Erste, was eine Vorlesefunktion ansagt.
 */
const sprung = document.querySelector('a[href="#inhalt"]')
if (sprung) sprung.textContent = t('Zum Inhalt springen')

render(<App />, document.getElementById('app')!)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js')
  })
}
